import React, { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

export default function Carousel({
  setter,
  objKey,
  slides = [],
  options = { loop: true, align: 'center' },
}) {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;

    // initialize derived state
    setScrollSnaps(emblaApi.scrollSnapList());
    onSelect();

    // keep state in sync on selection changes and re-measure
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', () => {
      setScrollSnaps(emblaApi.scrollSnapList());
      onSelect();
    });

    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect]);

  const scrollPrev = useCallback(
    () => emblaApi && emblaApi.scrollPrev(),
    [emblaApi]
  );
  const scrollNext = useCallback(
    () => emblaApi && emblaApi.scrollNext(),
    [emblaApi]
  );

  useEffect(() => {
    setter({ [objKey]: selectedIndex });
  }, [selectedIndex]);

  return (
    <div
      style={{
        border: '1px solid lightgray',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        marginTop: 10,
      }}
    >
      <section className="embla">
        <button
          className="embla__button embla__button--prev"
          onClick={scrollPrev}
          disabled={prevBtnDisabled}
          aria-label="Previous slide"
          type="button"
        >
          ‹
        </button>
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container">
            {slides.length === 0 ? (
              <div className="embla__slide embla__slide--empty">No slides</div>
            ) : (
              slides.map((data, index) => (
                <div
                  className={`embla__slide ${index === selectedIndex ? 'active' : ''}`}
                  key={data.id ?? index}
                >
                  <div className="embla__slide__inner">
                    <img
                      className="embla__slide__img"
                      src={data.image}
                      alt={data.alt ?? `slide-${index + 1}`}
                      draggable={false}
                    />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <button
          className="embla__button embla__button--next"
          onClick={scrollNext}
          disabled={nextBtnDisabled}
          aria-label="Next slide"
          type="button"
        >
          ›
        </button>
      </section>
    </div>
  );
}
